<template>
  <div class="h-screen w-full relative p-2 bg-HomeBack text-white">
    <div id="rectangle" class="h-56 w-full relative rounded-xl"></div>
    <div
      id="circle"
      class="absolute h-28 w-28 rounded-[50%] border-4 border-bgbacktest left-0 right-0 top-[170px] justify-center my-0 mx-auto"
    ></div>
    <div class="flex flex-col justify-center items-center mt-16">
      <h1 class="text-bgbutton font-bold">رستوران تخت جمشید شاندیز</h1>
    </div>
    <div class="grid grid-cols-2 gap-2 text-bgbutton mt-10 text-xs text-center">
      <div
        class="bg-bghomebutton rounded-lg flex flex-col items-center p-4 border border-bghomebutton shadow-2xl"
        @click="this.$contact.value = true"
      >
        <font-awesome-icon
          icon="phone-flip"
          class="fa-xl mb-2 text-ColorNerkh"
        />
        <span>ارتباط باما </span>
      </div>
      <a
        href="https://www.instagram.com/takhtejamshidshandiz/"
        class="bg-bghomebutton rounded-lg flex flex-col justify-center p-4 border border-bghomebutton shadow-xl items-center"
      >
        <svg
          fill="#000000"
          width="22px"
          height="22px"
          viewBox="0 0 32 32"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <title>instagram</title>
          <path
            d="M25.805 7.996c0 0 0 0.001 0 0.001 0 0.994-0.806 1.799-1.799 1.799s-1.799-0.806-1.799-1.799c0-0.994 0.806-1.799 1.799-1.799v0c0.993 0.001 1.798 0.805 1.799 1.798v0zM16 20.999c-2.761 0-4.999-2.238-4.999-4.999s2.238-4.999 4.999-4.999c2.761 0 4.999 2.238 4.999 4.999v0c0 0 0 0.001 0 0.001 0 2.76-2.237 4.997-4.997 4.997-0 0-0.001 0-0.001 0h0zM16 8.3c0 0 0 0-0 0-4.253 0-7.7 3.448-7.7 7.7s3.448 7.7 7.7 7.7c4.253 0 7.7-3.448 7.7-7.7v0c0-0 0-0 0-0.001 0-4.252-3.447-7.7-7.7-7.7-0 0-0 0-0.001 0h0zM16 3.704c4.003 0 4.48 0.020 6.061 0.089 1.003 0.012 1.957 0.202 2.84 0.538l-0.057-0.019c1.314 0.512 2.334 1.532 2.835 2.812l0.012 0.034c0.316 0.826 0.504 1.781 0.516 2.778l0 0.005c0.071 1.582 0.087 2.057 0.087 6.061s-0.019 4.48-0.092 6.061c-0.019 1.004-0.21 1.958-0.545 2.841l0.019-0.058c-0.258 0.676-0.64 1.252-1.123 1.726l-0.001 0.001c-0.473 0.484-1.049 0.866-1.692 1.109l-0.032 0.011c-0.829 0.316-1.787 0.504-2.788 0.516l-0.005 0c-1.592 0.071-2.061 0.087-6.072 0.087-4.013 0-4.481-0.019-6.072-0.092-1.008-0.019-1.966-0.21-2.853-0.545l0.059 0.019c-0.676-0.254-1.252-0.637-1.722-1.122l-0.001-0.001c-0.489-0.47-0.873-1.047-1.114-1.693l-0.010-0.031c-0.315-0.828-0.506-1.785-0.525-2.785l-0-0.008c-0.056-1.575-0.076-2.061-0.076-6.053 0-3.994 0.020-4.481 0.076-6.075 0.019-1.007 0.209-1.964 0.544-2.85l-0.019 0.059c0.247-0.679 0.632-1.257 1.123-1.724l0.002-0.002c0.468-0.492 1.045-0.875 1.692-1.112l0.031-0.010c0.823-0.318 1.774-0.509 2.768-0.526l0.007-0c1.593-0.056 2.062-0.075 6.072-0.075zM16 1.004c-4.074 0-4.582 0.019-6.182 0.090-1.315 0.028-2.562 0.282-3.716 0.723l0.076-0.025c-1.040 0.397-1.926 0.986-2.656 1.728l-0.001 0.001c-0.745 0.73-1.333 1.617-1.713 2.607l-0.017 0.050c-0.416 1.078-0.67 2.326-0.697 3.628l-0 0.012c-0.075 1.6-0.090 2.108-0.090 6.182s0.019 4.582 0.090 6.182c0.028 1.315 0.282 2.562 0.723 3.716l-0.025-0.076c0.796 2.021 2.365 3.59 4.334 4.368l0.052 0.018c1.078 0.415 2.326 0.669 3.628 0.697l0.012 0c1.6 0.075 2.108 0.090 6.182 0.090s4.582-0.019 6.182-0.090c1.315-0.029 2.562-0.282 3.716-0.723l-0.076 0.026c2.021-0.796 3.59-2.365 4.368-4.334l0.018-0.052c0.416-1.078 0.669-2.326 0.697-3.628l0-0.012c0.075-1.6 0.090-2.108 0.090-6.182s-0.019-4.582-0.090-6.182c-0.029-1.315-0.282-2.562-0.723-3.716l0.026 0.076c-0.398-1.040-0.986-1.926-1.729-2.656l-0.001-0.001c-0.73-0.745-1.617-1.333-2.607-1.713l-0.050-0.017c-1.078-0.416-2.326-0.67-3.628-0.697l-0.012-0c-1.6-0.075-2.108-0.090-6.182-0.090z"
          ></path>
        </svg>
        <!-- <img src="../assets/img/instagram.svg" class="filter_img" /> -->
        <span class="mt-2">اینستاگرام</span>
      </a>
    </div>
    <div>
      <div
        class="bg-bghomebutton rounded-lg flex flex-col justify-center text-bgbutton text-xs text-center border border-bghomebutton shadow-xl mt-3 font-bold"
        @click="convertAddress()"
      >
        <span class="mt-4">مشهد ، ابتدای شاندیز ، حدفاصل امام رضا ۳ و ۵</span>
        <div class="border-2 border-bgbutton p-2 rounded-md mx-2 my-4">
          <font-awesome-icon icon="location-dot" class="fa-xl text-colorfont" />
          <span class="my-2 mr-1">مشاهده آدرس روی نقشه</span>
        </div>
      </div>
    </div>
    <div class="flex items-center w-full mt-7">
      <button
        class="text-bgbutton bg-bgbuttontest p-3 mx-2 shadow-xl rounded-md w-full text-center font-bold text-sm"
        @click="this.$router.replace('/menu')"
      >
        مشاهده منوی رستوران
      </button>
    </div>
  </div>
  <transition name="fade">
    <div
      class="fixed h-screen w-screen top-0 bg-gray-500/50 z-30"
      v-if="modalLocation"
      @click="closeModalLocation"
    >
      <div
        class="bg-white rounded-lg w-screen mt-[30%] mx-auto p-4"
        @click.stop
      >
        <div id="map" class="w-screen h-96"></div>
      </div>
    </div>
  </transition>
</template>
<script>
import { mapMatching } from "../API/API";
import { getBanners } from "@/API/API";
import L from "leaflet";
export default {
  name: "HomeView",
  components: {},
  data() {
    return {
      options: {
        key: "web.e9fd05cc16f64a8b93c80241f5360686",
        maptype: "dreamy",
        poi: true,
        traffic: false,
        center: [36.30284183765441, 59.5958496945331],
        zoom: 13,
      },
      modalLocation: false,
      latitude: "36.412694155810044",
      longitude: "59.35103309655793",
    };
  },
  async created() {
    this.banners = (await getBanners()).data.result[0];
    document.getElementById(
      "rectangle"
    ).style.backgroundImage = `url(${this.banners.imgUrl})`;
    console.log(this.banners.imgUrl);
  },
  methods: {
    callmenu() {
      this.$router.replace("/menu/100");
    },
    closeModalLocation() {
      this.modalLocation = false;
    },

    convertAddress() {
      this.modalLocation = true;
      this.$nextTick(() => {
        mapMatching(this.latitude, this.longitude).then((resp) => {
          this.latitude = resp.data.snappedPoints[0].location.latitude;
          this.longitude = resp.data.snappedPoints[0].location.longitude;

          // اگر نقشه قبلاً ساخته شده بود، ابتدا آن را پاک کنید
          if (this.map) {
            this.map.remove();
          }

          // ایجاد نقشه در عنصر #map
          this.map = new L.Map("map").setView(
            [this.latitude, this.longitude],
            13
          );
          L.tileLayer(
            "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          ).addTo(this.map);

          const latLng = [this.latitude, this.longitude];
          L.marker(latLng).addTo(this.map);
        });
      });
    },
  },
};
</script>
<style scoped>
#rectangle {
  content: "";
  @apply bg-no-repeat bg-cover;
}

#circle {
  content: "";
  background-image: url("../assets/img/logo.png");
  @apply bg-no-repeat bg-cover;
}
svg {
  fill: #ffa500;
}
</style>
